export default __webpack_public_path__ + "images/0xda0053f0befcbcac208a3f867bb243716734d809.png";